import { COMMIT_SEARCH_PARAMS } from '../constants/searchParams';

export const commitSearchParamsAction = (payload) => ({
  type: COMMIT_SEARCH_PARAMS,
  payload,
});
